import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from './style/gstheme';

function ViewOnly(props) {

    return (
        props.compact ?
        <span data-test="view-only" className={props.classes.compactViewOnly}>View only</span>
        :
        <span data-test="view-only" className={props.classes.viewOnly}>(View only)</span>        
    );

}

ViewOnly.defaultProps = {
    compact: false
};

ViewOnly.propTypes = {
    classes: PropTypes.object,
    compact: PropTypes.bool
};

export default withStyles(styles)(ViewOnly);